import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { EngagementContent } from "PFApp/components/card_tx/content/engagement_content";
import { EngagementFooter } from "PFApp/components/card_tx/footer/engagement_footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type AuditEngagementVariantProps = Pick<
  CardTxContentProps,
  "task" | "type" | "isFeed" | "isDraft" | "numberOfRoles" | "handleShare"
>;

export const AuditEngagementVariant = ({
  task,
  type,
  isFeed,
  isDraft,
  numberOfRoles,
  handleShare
}: AuditEngagementVariantProps) => (
  <>
    <Header task={task} type={type} isFeed={isFeed} onShare={handleShare} />
    <Status isPrivate={task.private} isDraft={isDraft} />
    <EngagementContent task={task} isFeed={isFeed} />
    <EngagementFooter numberOfRoles={numberOfRoles} />
  </>
);
